import { ARTWORK_TYPE, IMAGE_TYPE } from "../based/Constants";
import { PositionModel } from "./PositionModel";

export class ArtworkPositionModel {
    constructor() {
        this.imageType = ARTWORK_TYPE.Front;
        this.positionModel = new PositionModel();
    }
}
